module.exports = __webpack_public_path__ + "fonts/iconfont.96c0e25a.woff";